// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".notice-popover p {\n  margin: 0;\n}\n.notice-popover .variable-message-class {\n  pointer-events: none;\n}", ""]);
// Exports
module.exports = exports;
